import { TrashIcon } from '@heroicons/react/20/solid';
import PropTypes from 'prop-types';
import CheckoutCartTotals from './CheckoutCartTotals';
import CheckoutRetainedAttemptStatus from './CheckoutRetainedAttemptStatus';

function CheckoutCartItems({
  cart,
  commercialInputsLocked,
  destroyCartItem,
  locale,
  onRetryRecovery,
  recoveryError,
  recoveryLoading,
  retainedAttempt,
  taxQuote,
}) {
  return (
    <>
      <ul className="divide-y divide-gray-200">
        {cart?.cartItemsAttributes?.map((cartItem) => (
          <li key={cartItem.id} className="flex px-4 py-6 sm:px-6">
            <div className="shrink-0">
              <img
                src={cartItem.product.featuredImage}
                alt={cartItem.product.name}
                className="w-20 rounded-md"
              />
            </div>

            <div className="ml-6 flex flex-1 flex-col">
              <div className="flex">
                <div className="min-w-0 flex-1">
                  <h4 className="font-medium text-base">{cartItem.name}</h4>
                  <p className="mt-1 text-gray-500 text-xs">
                    {cartItem.product.description}
                  </p>
                  <p className="mt-1 text-gray-500 text-xs">
                    {cartItem.patient ? (
                      <span>
                        Purchasing For:&nbsp;
                        <span className="font-bold">
                          {cartItem.patient.firstName}
                        </span>
                      </span>
                    ) : null}
                  </p>
                </div>

                <div className="ml-4 flow-root shrink-0">
                  <button
                    type="button"
                    className="-m-2.5 flex items-center justify-center bg-white p-2.5 text-gray-400 hover:text-gray-500 disabled:cursor-not-allowed disabled:text-gray-300"
                    onClick={() => destroyCartItem(cartItem.id)}
                    disabled={commercialInputsLocked}
                  >
                    <span className="sr-only">Remove {cartItem.name}</span>
                    <TrashIcon className="size-5" aria-hidden="true" />
                  </button>
                </div>
              </div>

              <div className="flex flex-1 items-end justify-between pt-2">
                <div className="text-sm">Qty: {cartItem.quantity}</div>

                <p className="mt-1 ml-4 font-medium text-gray-900 text-sm">
                  {(cartItem.price / 100).toLocaleString(locale, {
                    style: 'currency',
                    currency: 'USD',
                  })}
                </p>
              </div>
            </div>
          </li>
        ))}
      </ul>
      <CheckoutCartTotals
        cart={cart}
        locale={locale}
        retainedPaymentStatus={retainedAttempt?.status || null}
        taxQuote={taxQuote}
      />
      <CheckoutRetainedAttemptStatus
        onRetry={onRetryRecovery}
        recoveryError={recoveryError}
        recoveryLoading={recoveryLoading}
        retainedAttempt={retainedAttempt}
      />
    </>
  );
}

CheckoutCartItems.propTypes = {
  cart: PropTypes.shape({
    cartItemsAttributes: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        patient: PropTypes.shape({ firstName: PropTypes.string }),
        price: PropTypes.number.isRequired,
        product: PropTypes.shape({
          description: PropTypes.string,
          featuredImage: PropTypes.string,
          name: PropTypes.string.isRequired,
        }).isRequired,
        quantity: PropTypes.number.isRequired,
      }),
    ),
  }),
  commercialInputsLocked: PropTypes.bool.isRequired,
  destroyCartItem: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  onRetryRecovery: PropTypes.func.isRequired,
  recoveryError: PropTypes.object,
  recoveryLoading: PropTypes.bool.isRequired,
  retainedAttempt: PropTypes.object,
  taxQuote: PropTypes.object,
};

export default CheckoutCartItems;
